import React from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="top-center" // Position the toasts in the middle-top
      autoClose={3000} // Auto-close after 3 seconds
      hideProgressBar={true} // Hide the progress bar
      closeOnClick
      pauseOnHover
      draggable
      theme="light" // or "dark" based on your preference
      style={{ color: '#853372' }} // Set the background color
    />
  );
};

export default CustomToastContainer;
